import { transformColorRgba } from '../../mission-summary/components/colors';
import { CompassExerciseOverTime } from '@edwin-group/cj-graphql';

// 2025/2026
// September 2025, October 2025, November 2025, December 2025, January 2026, February 2026, March 2026, April 2026, May 2026, June 2026, July 2026

//  ----August 2026

// 2026/2027
// September 2026, October 2026, November 2026, December 2026, January 2027, February 2027, March 2027, April 2027, May 2027, June 2027, July 2027

const MONTHS: string[] = [
  'September',
  'October',
  'November',
  'December',
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
];

export const parseCompassExercisesOverTime = (reportData: CompassExerciseOverTime[], academicYear: string) => {
  const radarData = {
    labels: MONTHS.map((month, index) =>
      index < 4 ? month + ' - ' + academicYear.slice(0, 4) : month + ' - ' + academicYear.slice(5, 9),
    ),
    datasets:
      reportData?.map((item) => {
        const data = MONTHS.map((month) => {
          return item?.months?.find((item) => item?.monthName === month)?.value || 0;
        });

        return {
          label: item?.trait || '',
          data,
          fill: false,
          pointBackgroundColor: `#${item?.color}`,
          borderColor: `#${item?.color}`,
          backgroundColor: transformColorRgba(item?.color || '#FFFFFF', 0.3),
        };
      }) || [],
  };

  return radarData;
};
